import { useState } from "react";

// Fallback lead capture shown when the instant AVM isn't available for this
// agent yet (HomeValuation returns :needs_setup — tenant not provisioned). The
// old Home Value templates always rendered a {% lead_form %}; the new
// island-driven page relies on the registration gate for capture, which only
// appears AFTER a valuation. This restores capture for the unavailable case so
// the page never becomes a message-only dead-end: it posts to /_lead (the same
// CRM endpoint {% lead_form %} used) and shows a thank-you on success.
export default function NeedsSetupCapture({ agentName, leadDone, leadError, onSubmit }) {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [busy, setBusy] = useState(false);

  const inputStyle = {
    width: "100%",
    padding: "0.7rem 0.9rem",
    borderRadius: 10,
    border: "1px solid rgba(0,0,0,0.15)",
    fontSize: "1rem",
    boxSizing: "border-box",
    marginTop: "0.5rem",
  };

  if (leadDone) {
    return (
      <Box>
        Thanks! {agentName} will follow up with your home&apos;s value shortly.
      </Box>
    );
  }

  async function submit(e) {
    e.preventDefault();
    if (!email.trim() || !phone.trim()) return;
    setBusy(true);
    await onSubmit({ name: name.trim(), email: email.trim(), phone: phone.trim() });
    setBusy(false);
  }

  return (
    <Box>
      <div style={{ fontWeight: 700, fontSize: "1.05rem" }}>Instant estimates aren&apos;t available here just yet</div>
      <p style={{ margin: "0.35rem 0 0.5rem", opacity: 0.9, fontSize: "0.95rem" }}>
        Leave your details and {agentName} will follow up with your home&apos;s value.
      </p>
      <form onSubmit={submit}>
        <input
          type="text"
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder="Your name"
          aria-label="Your name"
          style={inputStyle}
        />
        <input
          type="tel"
          value={phone}
          onChange={(e) => setPhone(e.target.value)}
          placeholder="Mobile phone"
          aria-label="Mobile phone"
          autoComplete="tel"
          required
          style={inputStyle}
        />
        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="you@example.com"
          aria-label="Email address"
          required
          style={inputStyle}
        />
        {leadError && <div style={{ marginTop: "0.5rem", color: "#ffd2d2", fontSize: "0.85rem" }}>{leadError}</div>}
        <button type="submit" className="ss-c-btn ss-c-btn--accent" disabled={busy} style={{ marginTop: "0.6rem", width: "100%" }}>
          {busy ? "Sending…" : "Get my home value"}
        </button>
      </form>
    </Box>
  );
}

function Box({ children }) {
  return (
    <div style={{ marginTop: "1rem", padding: "1.1rem 1.25rem", borderRadius: 12, background: "rgba(255,255,255,0.14)", textAlign: "left" }}>
      {children}
    </div>
  );
}
